/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import GroupsList from './GroupsList';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { Actions, PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { DashboardIcon } from '../Common/Icons';
import { objectSort } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import GroupDetails from './GroupDetails';
import GroupsModal from './GroupsModal';
import useUserHubs from '../Hooks/useUserHubs';
import { useLocation } from 'react-router-dom';
import { getProfilePics, getUserHubs } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePicUrl } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { message } from 'antd';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { getStaffList } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import useStaffList from '../Hooks/useStaffList';

const Groups = ({ parentBread }) => {
  const trans = useSelector(translator);
  const currentUser = useSelector(getCurrentUser);
  const { providerid } = useMemo(() => currentUser, [currentUser]);
  const useruuid = useMemo(() => currentUser.useruuid, [currentUser]);
  const [action, setAction] = useState(null);
  const [record, setRecord] = useState(null);
  const [groupModalAction, setGroupModalAction] = useState(null);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [showGroupDeleteConfirmModal, setShowGroupDeleteConfirmModal] = useState(false);
  const [showGroupCallDeleteConfirmModal, setShowGroupCallDeleteConfirmModal] = useState(false);
  const [refreshGroupList, setRefreshGroupList] = useState(false);
  const deviceApi = useSelector((state) => state.apis.deviceApi);
  useStaffList({ useruuid });
  useUserHubs({ useruuid });
  const staffList = useSelector(getStaffList(useruuid));
  const [groupName, setGroupName] = useState('');
  const [scheduleModalData, setScheduleModalData] = useState(null);
  const [editScheduleData, setEditScheduleData] = useState(null);
  const [refreshSchedulePage, setRefreshSchedulePage] = useState(false);
  const [refreshMemberPage, setRefreshMemberPage] = useState(false);
  const [removeMemberUuid, setRemoveMemberUuid] = useState(null);
  const [removeMemberName, setRemoveMemberName] = useState(null);
  const [deleteScheduleCallObj, setDeleteScheduleCallObj] = useState(null);
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);
  const location = useLocation();
  const deviceCount = location.state?.count || 1000;
  const showPagination = deviceCount > 1000;
  const [limit, setLimit] = useState(showPagination ? 10 : deviceCount);
  const [offset, setOffset] = useState(0);
  const userData = useSelector((user) => user.data.userInfo);
  const updatedUserInfo = userData[useruuid];
  const timeZone = updatedUserInfo?.timezone ? updatedUserInfo?.timezone.split(' ')[0] : '';
  const [showRemoveMemberConfirmModal, setShowRemoveMemberConfirmModal] = useState(false);
  const userHubs = useSelector(getUserHubs(useruuid));
  const resourceMap = useSelector(getProfilePics());
  const mUserHubs = userHubs.map((hub) => ({
    ...hub,
    profilePic64: getProfilePicUrl(hub.useruuid, resourceMap, PhotoResolution.R64),
  }));

  const mOrderedUserHubs = useMemo(() => {
    return [...mUserHubs].sort(objectSort('firstname'));
  }, [mUserHubs]);

  const fetchDevices = (providerId, params) => {
    const errorCallback = (error) => {
      console.error('Error fetching list of devices:', error);
    };

    const successCallback = (data) => {
      // Handle success response if needed
    };

    let queryParams = {};
    if (!params) {
      queryParams.filterkey = 'category';
      queryParams.filtervalue = 'DEVICE-PRIMARY';
      queryParams.sortby = 'deviceid';
      queryParams.orderby = 'asc';
    } else {
      queryParams = { ...params };
    }
    try {
      deviceApi.getDevicesByProviderId(
        providerId,
        offset,
        limit,
        queryParams,
        apiCallback({
          translator: trans,
          errorCallback,
          failCallback: errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  useEffect(() => {
    fetchDevices(providerid);
  }, [providerid]);

  const mOrderedStaffList = useMemo(() => {
    if (!staffList || staffList.length === 0) {
      return [];
    }
    return [...staffList].sort(objectSort('firstname'));
  }, [staffList]);

  const getFilteredUserLists = useMemo(() => {
    if (!record?.invited_contacts) {
      return {
        filteredUserHubs: mOrderedUserHubs,
        filteredStaffList: mOrderedStaffList,
      };
    }

    const invitedUserIds = record.invited_contacts.map((contact) => contact.useruuid);

    const filteredUserHubs = mOrderedUserHubs.filter(
      (hub) => !invitedUserIds.includes(hub.useruuid)
    );

    const filteredStaffList = mOrderedStaffList.filter(
      (staff) => !invitedUserIds.includes(staff.useruuid)
    );

    return {
      filteredUserHubs,
      filteredStaffList,
    };
  }, [mOrderedUserHubs, mOrderedStaffList, record?.invited_contacts]);

  const onActionClick =
    (action, record, refresh = false) =>
    () => {
      setAction(action);
      setRecord(record);
      if (action !== null) setGroupName(record.name);
    };

  const header = (parentBread || []).concat({
    label: trans('DASHBOARD'),
    icon: <DashboardIcon />,
    onClick: onActionClick(null, null),
  });

  const onGroupModalActionClick = (action) => {
    setGroupModalAction(action);
    setShowGroupModal(true);
  };

  const groupDeleteAction = (action, record) => {
    setShowGroupDeleteConfirmModal(true);
    return;
  };

  const groupCallDeleteShowHandler = () => {
    setShowGroupCallDeleteConfirmModal(true);
    return;
  };

  const handleModalClose = () => {
    setShowGroupModal(false);
  };

  const closeGroupDeleteConfirmModal = () => {
    setShowGroupDeleteConfirmModal(false);
  };

  const closeGroupCallDeleteConfirmModal = () => {
    setLatestGroupInfo(); // Upating group info on deletion
    setShowGroupCallDeleteConfirmModal(false);
  };

  const handleMembersAdd = (membersData) => {
    const handleCreateSuccess = () => {
      setGroupModalAction(null);
      setShowRemoveMemberConfirmModal(false);
      setLatestGroupInfo();
      // message.success("Group member added successfully!");
    };

    const handleError = (error) => {
      setGroupModalAction(null);
      setShowRemoveMemberConfirmModal(false);
      setLatestGroupInfo();
      console.error('Error on group member add:', error);
    };

    const groupuuid = record?.groupuuid || null;
    const addMemberDataSet = [
      ...membersData.accounts.map((account) => account.useruuid),
      ...membersData.staff.map((staff) => staff.useruuid),
    ];

    const newAddMemberDataSet = addMemberDataSet.map((member) => {
      return { useruuid: member };
    });

    userGroupApi.addUserToGroup(
      groupuuid,
      newAddMemberDataSet,
      apiCallback({
        translator: trans,
        failCallback: handleError,
        errorCallback: handleError,
        successCallback: handleCreateSuccess,
      })
    );
  };

  const setLatestGroupInfo = () => {
    const groupuuid = record?.groupuuid || null;

    const handleSuccess = (data) => {
      setRecord(data?.usergroup);
      setGroupName(data?.usergroup?.name);
    };

    const handleError = (error) => {
      console.error('Error on group member add:', error);
    };

    userGroupApi.getUserGroupById(
      groupuuid,
      apiCallback({
        translator: trans,
        failCallback: handleError,
        errorCallback: handleError,
        successCallback: handleSuccess,
      })
    );
  };

  const closeRemoveMemberConfirmModal = () => {
    setShowRemoveMemberConfirmModal(false);
  };

  const isStaffAdmin = useMemo(() =>
    updatedUserInfo ? updatedUserInfo?.staffadmin : false[updatedUserInfo]
  );

  const isStaff = useMemo(() => {
    return updatedUserInfo
      ? updatedUserInfo?.permission_level === 'Staff' && updatedUserInfo?.staffadmin === false
      : false;
  }, [updatedUserInfo]);

  return (
    <>
      {!action ? (
        <GroupsList
          parentBread={header}
          showGroupModal={showGroupModal}
          setShowGroupModal={setShowGroupModal}
          onGroupModalActionClick={onGroupModalActionClick}
          onActionClick={onActionClick}
          action={action}
          refreshGroupList={refreshGroupList}
          useruuid={useruuid}
          userInfo={updatedUserInfo}
          isStaffAdmin={isStaffAdmin}
        />
      ) : action === Actions.viewGroupDetails ? (
        <GroupDetails
          record={record}
          onGroupModalActionClick={onGroupModalActionClick}
          timeZone={timeZone}
          groupName={groupName}
          setShowRemoveMemberConfirmModal={setShowRemoveMemberConfirmModal}
          setScheduleModalData={setScheduleModalData}
          userInfo={updatedUserInfo}
          refreshSchedulePage={refreshSchedulePage}
          refreshMemberPage={refreshMemberPage}
          isStaffAdmin={isStaffAdmin}
          setRemoveMemberUuid={setRemoveMemberUuid}
          setRemoveMemberName={setRemoveMemberName}
          isStaff={isStaff}
          loginUserTimeformat={{ is24hoursformat: updatedUserInfo?.is24hoursformat }}
        />
      ) : (
        trans('ONACTIONCLICKNOTFOUND')
      )}

      <GroupsModal
        showGroupModal={showGroupModal}
        closeGroupModal={handleModalClose}
        modalLoading={modalLoading}
        groupModalAction={groupModalAction}
        groupDeleteAction={groupDeleteAction}
        showGroupDeleteConfirmModal={showGroupDeleteConfirmModal}
        closeGroupDeleteConfirmModal={closeGroupDeleteConfirmModal}
        record={record}
        onActionClick={onActionClick}
        setRefreshGroupList={setRefreshGroupList}
        userHubsData={getFilteredUserLists.filteredUserHubs || []}
        staffListData={getFilteredUserLists.filteredStaffList || []}
        onMembersAdd={handleMembersAdd}
        userInfo={updatedUserInfo}
        timeZone={timeZone}
        setGroupName={setGroupName}
        showRemoveMemberConfirmModal={showRemoveMemberConfirmModal}
        closeRemoveMemberConfirmModal={closeRemoveMemberConfirmModal}
        scheduleModalData={scheduleModalData}
        groupName={groupName}
        setEditScheduleData={setEditScheduleData}
        editScheduleData={editScheduleData}
        onGroupModalActionClick={onGroupModalActionClick}
        setRefreshSchedulePage={setRefreshSchedulePage}
        setRefreshMemberPage={setRefreshMemberPage}
        isStaffAdmin={isStaffAdmin}
        removeMemberUuid={removeMemberUuid}
        removeMemberName={removeMemberName}
        setLatestGroupInfo={setLatestGroupInfo}
        showGroupCallDeleteConfirmModal={showGroupCallDeleteConfirmModal}
        closeGroupCallDeleteConfirmModal={closeGroupCallDeleteConfirmModal}
        groupCallDeleteShowHandler={groupCallDeleteShowHandler}
        setDeleteScheduleCallObj={setDeleteScheduleCallObj}
        deleteScheduleCallObj={deleteScheduleCallObj}
        setGroupModalAction={setGroupModalAction}
        setShowRemoveMemberConfirmModal={setShowRemoveMemberConfirmModal}
        isStaff={isStaff}
        loginUserTimeformat={{ is24hoursformat: updatedUserInfo?.is24hoursformat }}
      />
    </>
  );
};

Groups.propTypes = {
  parentBread: PropTypes.arrayOf(PropTypes.object),
};

export default Groups;
